import apiClient from '@/plugins/axios';

export default {
	getRoundHistoryQuestions(params, opts = {}) {
		params.pageNumber = params.currentPage;

		return apiClient.get('v1/RoundHistoryQuestion', { params, ...opts });
	},

	getRoundHistoryQuestion(roundHistoryQuestionId) {
		return apiClient.get(`v1/RoundHistoryQuestion/${roundHistoryQuestionId}`);
	},

	createRoundHistoryQuestion(roundHistoryQuestion) {
		return apiClient.post('v1/RoundHistoryQuestion', roundHistoryQuestion);
	},

	updateRoundHistoryQuestion(roundHistoryQuestion) {
		var roundHistoryQuestionId = roundHistoryQuestion.id;

		return apiClient.put(
			`v1/RoundHistoryQuestion/${roundHistoryQuestionId}`,
			roundHistoryQuestion
		);
	},

	deleteRoundHistoryQuestion(roundHistoryQuestionId) {
		return apiClient.delete(
			`v1/RoundHistoryQuestion/${roundHistoryQuestionId}`
		);
	},

	getRoundHistoryQuestionLists(searchParam) {
		var query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.roundHistoryId
			? `&RoundHistoryId=${searchParam.roundHistoryId}`
			: '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';

		return apiClient.get(`v1/RoundHistoryQuestionList${query}`);
	},

	getRoundHistoryQuestionList(roundHistoryQuestionListId) {
		return apiClient.get(
			`v1/RoundHistoryQuestionList/${roundHistoryQuestionListId}`
		);
	},

	createRoundHistoryQuestionList(roundHistoryQuestionList) {
		return apiClient.post(
			'v1/RoundHistoryQuestionList',
			roundHistoryQuestionList
		);
	},

	updateRoundHistoryQuestionList(roundHistoryQuestionList) {
		var roundHistoryQuestionListId = roundHistoryQuestionList.id;

		return apiClient.put(
			`v1/RoundHistoryQuestionList/${roundHistoryQuestionListId}`,
			roundHistoryQuestionList
		);
	},

	deleteRoundHistoryQuestionList(roundHistoryQuestionListId) {
		return apiClient.delete(
			`v1/RoundHistoryQuestionList/${roundHistoryQuestionListId}`
		);
	}
};
